import { fabric } from "fabric";
fabric.textureSize = 4096;
// Filtros sem WebGL: o contexto WebGL e as texturas das fotos ficam na
// memória de vídeo do totem, e quando ela acaba o Chrome apaga os canvas (o
// editor e a prévia ficam brancos). As fotos da câmera do totem são pequenas
// e os filtros em Canvas 2D dão conta.
fabric.enableGLFiltering = false;
fabric.initFilterBackend = function () {
  if (
    fabric.enableGLFiltering &&
    fabric.isWebglSupported &&
    fabric.isWebglSupported(fabric.textureSize)
  ) {
    console.log("max texture size: " + fabric.maxTextureSize);
    return new fabric.WebglFilterBackend({ tileSize: fabric.textureSize });
  } else if (fabric.Canvas2dFilterBackend) {
    return new fabric.Canvas2dFilterBackend();
  }
};

fabric.Canvas.prototype.getItem = function (id) {
  let object = null,
    objects = this.getObjects();

  for (let i = 0, len = this.size(); i < len; i++) {
    if (objects[i].id && objects[i].id === id) {
      object = objects[i];
      break;
    }
  }
  return object;
};
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = "white";
fabric.Object.prototype.cornerStyle = "circle";
fabric.Object.prototype.borderColor = "black";
fabric.Object.prototype.cornerStrokeColor = "black";

export default fabric;
